import axios from "axios";
import mainVue from "@/main.js";
const qs = require("qs");
export const env = process.env.NODE_ENV;
export const instance = axios.create({
  // baseURL:
  //   env === "development" ? "/api/app/v1/" : "https://api.menuorg.com/app/v1/"
  baseURL: "https://api.menuorg.com/app/v1/"
});
// axios.defaults.baseURL = '/app/v1'
// axios.defaults.baseURL = '/app/v1'
function getToken() {
  var token = sessionStorage.getItem("token");
  return { token };
}

instance.interceptors.request.use(
  config => {
    const { token } = getToken();
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
// Cannot read property 'status_code' of undefined
instance.interceptors.response.use(
  res => {
    if (res.data.status_code == 200) {
      return res.data;
    } else {
      // mainVue.$message.error(res.data.message)
      if (res.data.message.indexOf("log") !== -1) {
        sessionStorage.clear();
        mainVue.$router.push({ name: "login" });
        mainVue.$message.error("logout");
      } else {
        // if (res.data.success_list) {
        //   return Promise.reject(res.data.success_list[0].failure_list);
        // } else {
        //   return Promise.reject(res.data.message);
        // }
        // return res.data;
        // return false
      }
      return res.data;
      // return Promise.reject(res.data.message);
    }
  },
  err => {
    if (err.response) {
      if (err.response.status !== 200) {
        // window.location.href = "/auth/login";
      }
      if (err.response.data) {
        return Promise.reject(err.response.data);
      }
      return Promise.reject(err.response);
    }
    return Promise.reject(err);
  }
);
export const fetchFoodsCategoryList = payload =>
  instance.get("/menu/get_dishes_series", { params: payload });

// 新建食品分类
export const createOneFoodsCategory = payload => {
  return instance.post(`/menu/add_dishes_series`, payload);
};
// 删除食品分类
export const deleteOneFoodsCategory = payload =>
  instance.post("/menu/del_dishes_series", payload);
// 食品列表
// export const fetchFoodsList = (payload) => instance.get("/foods", { params: payload });
export const fetchFoodsList = payload =>
  instance.get("/menu/get", { params: payload });
// 更新食品 /app/v1/menu/add
export const updateOneFoods = payload => instance.post("/menu/update", payload);

// 添加食品
// export const createOneFoods = (payload) => instance.post("/foods", payload);
export const createOneFoods = payload => instance.post("/menu/add", payload);

export const addUser = payload => instance.post("/user/add", payload);
// /app/v1/menu/get_1616770614933 /app/v1/menu/get_by_dishes_id
// 编辑获取原有商品信息
export const fetchOneFoods = payload =>
  instance.get("/menu/get_by_dishes_id", { params: payload });
// export const fetchOneFoods = (id) => instance.get(`/foods/${id}`);
// 修改餐厅开放状态
export const fetchupdate_open = payload =>
  instance.post("/restaurant/update_open", payload);

// 删除已上传到服务器的文件
export const deleteUploadedFile = filename =>
  instance.delete(`/uploads/${filename}`);

//获取评价列表
export const fetchRatings = payload =>
  instance.get("/rating/get_all", { params: payload });
//删除评价
export const deleteOneRating = id => instance.post(`/rating/delete`, payload);
//批量删除评价
export const deleteManyRatings = payload =>
  instance.post(`/rating/delete`, payload);
// 批量新增评论
export const ratingBrushApi = payload =>
  instance.post(`/rating/brush`, payload);

// 商家管理

export const fetchSeller = payload =>
  instance.get("/restaurant/get_by_id", { params: payload });
export const fetchFoodsStatistic = payload =>
  instance.get("/food-statistic", { params: payload });
// export const updateSeller = (id, payload) => instance.patch(`/seller/${id}`, payload);
// 新增商家信息
export const addSeller = payload => instance.post(`/restaurant/add`, payload);
// 修改商家信息
export const updateSeller = payload =>
  instance.post(`/restaurant/update`, payload);

// 修改营业状态
export const updateBusinessApi = payload =>
  instance.post(`/restaurant/update_business`, payload);
// 修改密码

// export const updatePassword = (id, payload) => instance.patch(`/administrators/${id}/change-password`, payload);
// 修改账户信息

// export const updateAccount = (id, payload) => instance.patch(`/administrators/${id}/change-account`, payload);
// 登录
// http://123.56.124.33:5000/api/admin/administrators/login
// http://localhost:8080/api/admin/administrators/login
export const login = payload => instance.post("/login", payload);
// 根据订单号查询订单

export const getOrderById = payload =>
  instance.get("/order/get_by_id", { params: payload });

export const getOrderByOm = payload =>
  instance.get("/order/get_by_platform", { params: payload });

export const fetchAdministratorList = payload =>
  instance.get("/user/get_role_list", { params: payload });

// 获取用户列表
export const getUserListApi = payload =>
  instance.get("/user/get_list", { params: payload });
// 获取洲列表
export const getContinentApi = payload =>
  instance.get("/address/state/get", { params: payload });

// 获取县列表
export const getCountyApi = payload =>
  instance.get("/address/county/get", { params: payload });
// 获取菜单
export const getMenuApi = payload =>
  instance.get("/menu/get", { params: payload });
// export const UrlgetState = '/address/state/get' // 机构消息通知
// export const getContinentApi = async (data) => {
//   try {

//     const res = await axios.get(UrlgetState, { params: data })
//     console.log(res, 'res')
//     if (res.status_code == 200) {
//       for (let i in res.items) {
//         res.items[i]['value'] = res.items[i].id,
//         res.items[i]['label'] = res.items[i].state
//       }
//     }
//     return res
//   } catch (err) {
//     console.log(err)
//   }
// }
// 图片上传
export const imageUpApi = payload => instance.get("/image/up", payload);
// 数据统计
export const browseRecordsApi = payload =>
  instance.get("/browse_records/get", { params: payload });
// 获取餐厅列表
export const getSellListApi = payload =>
  instance.get("/restaurant/get_list", { params: payload });

// 获取订单列表
// export const getByRdApi = (payload) => instance.get("/order/get_by_rd", { params: payload });
export const getByRdApi = payload =>
  instance.get("/order/get_by_rd_two", { params: payload });
// 修改订单状态
export const getOrderUpdateStatus = payload =>
  instance.post("/order/update_status", payload);

// 删除食品
export const deleteOneFoods = payload => instance.post("/menu/delete", payload);
// /menu/update_dishes_status
// /app/v1/menu/update_dishes_status
// /app/v1/menu/update_dishes_status

// 上下架售罄
export const updateFoodStatus = payload =>
  instance.post("/menu/update_dishes_status", payload);
export const enableOneFood = id => instance.patch(`/foods/${id}/enable`);
export const disableOneFood = id => instance.patch(`/foods/${id}/disable`);
// 修改密码

export const updatePasswordApi = payload =>
  instance.post("/user/update", payload);
// 获取指定用户信息
export const getUserInfoApi = payload =>
  instance.get("/user/get_by_id", { params: payload });
// 更新食品分类
export const updateOneFoodsCategory = payload =>
  instance.post("/menu/update_dishes_series", payload);
// 获取餐厅订单统计结果(商家/平台可用
export const stats_rd_order_by_timeApi = payload =>
  instance.get("/order/stats_rd_order_by_time", { params: payload });
// 获取餐厅类型
export const getRestaurantTypeApi = payload =>
  instance.get("/restaurant_type/get", { params: payload });
// 获取订单付款信息

export const get_credit_cardApi = payload =>
  instance.get("/order/get_credit_card", { params: payload });

// 获取餐厅指定营业状态
export const get_businessApi = payload =>
  instance.get("/restaurant/get_business", { params: payload });
// 删除指定餐厅
export const deleteRestaurantApi = payload =>
  instance.post("/restaurant/delete", payload);

export const deleteUserApi = payload => instance.post("/user/delete", payload);
// 获取信用卡查看密码

export const get_passwordApi = payload =>
  instance.get("/restaurant/get_password", { params: payload });

// 新增拥挤抽取方式
export const restaurant_commissionAddApi = payload =>
  instance.post("/restaurant_commission/add", payload);

// 编辑佣金抽取方式
export const restaurant_commissionEaditApi = payload =>
  instance.post("/restaurant_commission/update", payload);
// 获取佣金抽成方式
export const restaurant_commissionGetApi = payload =>
  instance.get("/restaurant_commission/get", { params: payload });
// 导入菜单
export const menu_by_json_api = payload =>
  instance.post("/import/menu_by_json", payload);
// 添加dns域名
export const dns_by_json_api = payload =>
  instance.post("/restaurant/update_domain", payload);

// 餐厅新增打印机
export const add_by_rd_api = payload =>
  instance.post("/printer/add_by_rd", payload);

export const get_rating_api = payload =>
  instance.get("/rating/get_by_rd", { params: payload });

export const photo_library_get_api = payload =>
  instance.get("/photo_library/get", { params: payload });

// 商家添加精选评论
export const rating_brush = payload =>
  instance.get("/rating/brush", { params: payload });

// 新增图片库图片
export const photo_library_add_api = payload =>
  instance.post("/photo_library/add", payload);

// 修改关键字

export const update_keywords_api = payload =>
  instance.post("/restaurant/update_keywords", payload);
// 获取关键字
export const get_keywords_api = payload =>
  instance.get("/restaurant/get_keywords", { params: payload });
// 获取账单
export const bill_get_list_api = payload =>
  instance.get("/bill/get_list", { params: payload });
// 修改账单
export const bill_update_api = payload =>
  instance.post("/bill/update", payload);
// 删除图片
export const photo_library_delete_api = payload =>
  instance.post("/photo_library/delete", payload);
// 获取无菜单餐厅
export const get_not_menu_api = payload =>
  instance.get("/restaurant/get_not_menu", { params: payload });
// 单独修改菜单价
export const update_dishes_price_api = payload =>
  instance.post("/menu/update_dishes_price", payload);

// 运营后台登录
export const platform_to_restaurant_api = payload =>
  instance.post("/platform_to_restaurant", payload);
// 清空菜单

export const removeAllMenu = payload =>
  instance.post("/menu/delete_all", payload);
// 黑名单用户列表

export const getBlocklist = payload =>
  instance.get("/user_blocklist/get_list", { params: payload });

// 新增黑名单
export const addBlock = payload =>
  instance.post("/user_blocklist/add", payload);
// 删除黑名单
export const deleteBlock = payload =>
  instance.post("/user_blocklist/delete", payload);
// 修改黑名单
export const editBlock = payload =>
  instance.post("/user_blocklist/update", payload);
// 添加关联图片

export const addPublicityImageApi = payload =>
  instance.post("/restaurant/add_image", payload);
// 删除宣传图

export const deleteImgApi = payload =>
  instance.post("/restaurant/delete_image", payload);
// 获取信用卡类型信息(全可用)
export const getCardTypeListApi = payload =>
  instance.get("/card/type_get", { params: payload });

// 删除图片
export const deleteDishesImgApi = payload =>
  instance.post("/menu/update_dishes_image", payload);
// 更新信用卡类型
export const updateCardTypeApi = payload =>
  instance.post("/restaurant/update_card_type", payload);

export const getUSAMapData = payload =>
  instance.get("./usa-map.json", { params: payload });

// 运营平台删除订单

export const mgmtCancelOrderApi = payload =>
  instance.post("/order/mgmt_cancel_order", payload);
// 获取doordash外送
export const getDoordashStatus = payload =>
  instance.get("/order/doordash_deliveries_status", { params: payload });
// 设置doordash 外送
export const setDoordashStyleApi = payload =>
  instance.post("/restaurant/update_platform_delivery", payload);
// 设置菜系排序
export const setShortApi = payload =>
  instance.post("/menu/update_dishes_series_sort", payload);

// 设置备注信息
export const restaurantManageAddApi = payload =>
  instance.post("restaurant_manage/add", payload);
// 增加黑名单
export const blockListAddApi = payload =>
  instance.post("/user_blocklist/add", payload);
// 修改邮件
export const update_order_notifyApi = payload =>
  instance.post("/restaurant/update_order_notify", payload);

// 获取平台反馈建议
export const getgetSuggestApi = payload =>
  instance.get("/system/get_suggest", { params: payload });

export const update_rateApi = payload =>
  instance.post("/restaurant/update_rate", payload);

export const sendFeedbackApi = payload =>
  instance.post("/email _info/mgmt_delivery", payload);

// 菜单序号
export const changeMenuShortApi = payLoad =>
  instance.post("/menu/update_sort", payLoad);

export const modifyPasswordApi = payLoad =>
  instance.post("/user/forget_password/modify_password", payLoad);



// WEBPACK FOOTER //
// ./src/helper/request.js